<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 10109 10109"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g>
  <rect class="fil0" width="10109" height="10109" rx="986" ry="986" />
   <g id="_597833416">
   <rect class="fil1 str0" x="1274" y="1274" width="7561" height="7561" rx="704" ry="704" />
     <line class="fil1 str0" x1="5055" y1="1274" x2="5055" y2="8835" />
  </g>
   <g id="_597833128">
   <circle class="fil2 str1" cx="3266" cy="5055" r="254" />
     <circle class="fil2 str1" cx="6843" cy="5055" r="254" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'MultiswitchDouble',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 460.288
}

.str1 {
  stroke: #FEFEFE;
  stroke-width: 87.6849
}

.fil1 {
  fill: none
}

.fil2 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
